module.exports = __webpack_public_path__ + "img/pd-img13.f3d60490.png";